import { useMemo } from 'react';
import { DEFAULT_CHAIN, USDT_DATA } from '@package/smart-wallet/constants';
import { useSmartWallet } from '@package/smart-wallet/providers';
import { useAccount, useBalance } from 'wagmi';

export const useGetUserBalance = () => {
  const { chain } = useAccount();
  const { smartAccountAddress, isLoading: isSmartWalletLoading } =
    useSmartWallet();

  /* Queries */
  const {
    data,
    isError,
    error,
    isLoading: isBalanceLoading,
    refetch,
  } = useBalance({
    address: smartAccountAddress,
    token: (USDT_DATA as any)[chain?.id ?? DEFAULT_CHAIN.id]?.contractAddress,
  });

  /* Memo */
  const isLoading = useMemo(() => {
    return isSmartWalletLoading || isBalanceLoading;
  }, [isSmartWalletLoading, isBalanceLoading]);

  const { tokenSymbol, tokenAmount, tokenDecimals } = useMemo(() => {
    return {
      tokenSymbol: data?.symbol,
      tokenAmount: data?.value.toString(),
      tokenDecimals: data?.decimals,
    };
  }, [data]);

  /* Return */
  return {
    tokenSymbol,
    tokenAmount,
    tokenDecimals,
    isLoading,
    isError,
    error,
    refetch,
  };
};
